import { DocumentoRequestUpdate, DocumentoRequestUpload } from 'api/Assessor/documentos';
import { AssembleiasConvocado } from 'api/Associado/convocado';
import { DocumentoResponse } from 'api/Associado/documentos';
import { IAssembleiaResultadosVotos } from './AssembleiasAssessorReducer';
import {
  IAssembleiaAssociado,
  IAssembleiaAssociadoEvento,
  IAssembleiaAssociadoPauta, IAssembleiaAssociadoRespostaPauta, IAssembleiaContasAssociado,
  IAssembleiasAssociadoDuvidas
} from './AssembleiasAssociadoReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH';

export const ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA =
  'ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA';

export const ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA =
 'ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA';

 export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA =
 'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA';

 export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_RESULTADO_VOTO_PAUTA =
 'ASSEMBLEIAS_ASSOCIADO_ACTIONS_RESULTADO_VOTO_PAUTA';

export const ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS =
 'ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS';
export const ASSEMBLEIAS_ASSOCIADO_LOAD_DOCUMENTOS =
 'ASSEMBLEIAS_ASSOCIADO_LOAD_DOCUMENTOS';
export const ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_CADASTRAR =
 'ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_CADASTRAR';
export const ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_ALTERAR =
 'ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_ALTERAR';
export const ASSEMBLEIAS_ASSOCIADO_DELETANDO_DOCUMENTO =
 'ASSEMBLEIAS_ASSOCIADO_DELETAR_DOCUMENTO';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES';

export interface IAssembleiasAssociadoRegistraPresenca {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA;
  payload: {
    cpfCnpj: string,
    idsConvocados: number[],
    assembleiaId: number,
  }
}

export interface IAssembleiasAssociadoRegistraVoto {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO;
}

export interface IAssembleiasAssociadoLoadingPautas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadPautas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS;
  assembleiaId: number;
  payload: IAssembleiaAssociadoPauta[];
}
export interface IAssembleiasAssociadoActionResultadoVoto {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_RESULTADO_VOTO_PAUTA;
  payload: IAssembleiaResultadosVotos;
}
export interface IAssembleiasAssociadoLoadResutadosVoto {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_RESULTADO_VOTO_PAUTA;
  payload: boolean;
}
export interface IAssembleiasAssociadoLoadingContas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadContas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS;
  payload: IAssembleiaContasAssociado;
}

export interface IAssembleiasAssociadoLoadingAll {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadAll {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL;
  payload: IAssembleiaAssociado[];
}

export interface IAssembleiasAssociadoLoadingDemaisAssembleias {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DEMAIS_ASSEMBLEIAS;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadDemaisAssembleias {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DEMAIS_ASSEMBLEIAS;
  payload: IAssembleiaAssociado[];
}

export interface IAssembleiaAssociadoDeleteCurrentEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT;
  payload: undefined;
}

export interface IAssembleiaAssociadoLoadingEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT;
  payload: IAssembleiaAssociadoEvento;
}

export interface IAssembleiaAssociadoRequestFile {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE;
  payload: number[];
}

export interface IAssembleiaAssociadoDownloadFileSuccess {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS;
  payload: number[];
}

export interface IAssembleiaAssociadoLoadingByCpfCnpj {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadByCpfCnpj {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ;
  payload: AssembleiasConvocado;
}

export interface IAssembleiaAssociadoLoadingDuvidas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadDuvidas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS;
  payload: IAssembleiasAssociadoDuvidas;
}

export interface IAssembleiaAssociadoRefresh {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH;
  payload: IWSAssembleia;
}

export interface IAssembleiaAssociadoLoadingPautaResposta {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA,
  payload: boolean
}

export interface IAssembleiaAssociadoLoadPautaResposta {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA,
  payload: IAssembleiaAssociadoRespostaPauta
}

export interface IAssembleiaAssociadoLoadingDocumento {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOADING_DOCUMENTOS;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadDocumento {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOAD_DOCUMENTOS;
  payload: DocumentoResponse[];
}

export interface IAssembleiaAssociadoDocumentoCadastrar {
  type: typeof ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_CADASTRAR;
  payload: DocumentoRequestUpload;
}

export interface IAssembleiaAssociadoDocumentoAlterar {
  type: typeof ASSEMBLEIAS_ASSOCIADO_DOCUMENTOS_ALTERAR;
  payload: DocumentoRequestUpdate;
}

export interface IAssembleiaAssociadoDeletarDocumento {
  type: typeof ASSEMBLEIAS_ASSOCIADO_DELETANDO_DOCUMENTO;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadingTotalConvocacoes {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_TOTAL_CONVOCACOES;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadTotalConvocacoes {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_TOTAL_CONVOCACOES;
  payload: number;
}

export type AssembleiasAssociadoActionTypes =
  | IAssembleiasAssociadoRegistraPresenca
  | IAssembleiasAssociadoRegistraVoto
  | IAssembleiasAssociadoLoadingPautas
  | IAssembleiasAssociadoLoadPautas
  | IAssembleiasAssociadoLoadingContas
  | IAssembleiasAssociadoLoadContas
  | IAssembleiasAssociadoLoadingAll
  | IAssembleiasAssociadoLoadAll
  | IAssembleiasAssociadoLoadingDemaisAssembleias
  | IAssembleiasAssociadoLoadDemaisAssembleias
  | IAssembleiaAssociadoDeleteCurrentEvent
  | IAssembleiaAssociadoLoadingEvent
  | IAssembleiaAssociadoLoadEvent
  | IAssembleiaAssociadoRequestFile
  | IAssembleiaAssociadoDownloadFileSuccess
  | IAssembleiaAssociadoLoadingByCpfCnpj
  | IAssembleiaAssociadoLoadByCpfCnpj
  | IAssembleiaAssociadoLoadingDuvidas
  | IAssembleiaAssociadoLoadDuvidas
  | IAssembleiaAssociadoRefresh
  | IAssembleiaAssociadoLoadingPautaResposta
  | IAssembleiaAssociadoLoadPautaResposta
  | IAssembleiaAssociadoLoadingDocumento
  | IAssembleiaAssociadoLoadDocumento
  | IAssembleiaAssociadoDocumentoAlterar
  | IAssembleiaAssociadoDocumentoCadastrar
  | IAssembleiaAssociadoDeletarDocumento
  | IAssembleiasAssociadoActionResultadoVoto
  | IAssembleiasAssociadoLoadResutadosVoto
  | IAssembleiaAssociadoLoadingTotalConvocacoes
  | IAssembleiaAssociadoLoadTotalConvocacoes